import axios from 'axios';

export default {
  getDataTableFilters({ commit }, tableLabel) {
    return axios.get(`/ajax/spa/${tableLabel}/list-filters/`)
      .then(({ data }) => {
        commit('setDataTableFilters', data);
      });
  },
};
